import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { colors } from '@material-ui/core';
import { Chart } from './components';

const ChargeAndLinkPay = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const chartColor = [
    colors.blue[700],
    colors.orange[500],
    colors.lightBlue[400],
    colors.green[500]
  ];
  const [labels, setLabels] = useState([]);
  const [data, setData] = useState([]);
  const dashboard = useSelector(({ dashboard }) => dashboard.data);

  useEffect(() => {
    if (dashboard) {
      setLabels(dashboard.chargeAndLinkpay.label);
      const newdata = dashboard.chargeAndLinkpay.dataSet.map((item, index) => {
        return {
          label: item.name,
          backgroundColor: chartColor[index],
          data: item.data
        };
      });
      setData(newdata);
    }
  }, [dashboard, chartColor]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Charge and Link pay" />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Chart
              className={classes.chart}
              data={data}
              labels={labels}
            />
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

ChargeAndLinkPay.propTypes = {
  className: PropTypes.string
};

export default ChargeAndLinkPay;

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  chart: {
    padding: theme.spacing(4, 2, 0, 2),
    height: 400
  }
}));
